import { combineReducers } from 'redux';
import { loadingBarReducer as loadingBar } from 'react-redux-loading-bar';

import locale, { LocaleState } from './locale';
import authentication, { AuthenticationState } from './authentication';
import applicationProfile, { ApplicationProfileState } from './application-profile';

import administration, { AdministrationState } from 'app/modules/administration/administration.reducer';
import userManagement, { UserManagementState } from 'app/modules/administration/user-management/user-management.reducer';
import register, { RegisterState } from 'app/modules/account/register/register.reducer';
import activate, { ActivateState } from 'app/modules/account/activate/activate.reducer';
import password, { PasswordState } from 'app/modules/account/password/password.reducer';
import settings, { SettingsState } from 'app/modules/account/settings/settings.reducer';
import passwordReset, { PasswordResetState } from 'app/modules/account/password-reset/password-reset.reducer';
import staticPage, { StaticPageState } from 'app/modules/static-page/static-page.reducer';
// prettier-ignore
import zone, {
  ZoneState
} from 'app/entities/zone/zone.reducer';
// prettier-ignore
import pricing, {
  PricingState
} from 'app/entities/pricing/pricing.reducer';
// prettier-ignore
import session, {
  SessionState
} from 'app/entities/session/session.reducer';
// prettier-ignore
import event, {
  EventState
} from 'app/entities/event/event.reducer';
// prettier-ignore
import site, {
  SiteState
} from 'app/entities/site/site.reducer';
/* jhipster-needle-add-reducer-import - JHipster will add reducer here */

// prettier-ignore
import order, {
  OrderState
} from 'app/entities/order/order.reducer';

import payment, {
  PaymentState
} from 'app/entities/payment/payment.reducer';

// prettier-ignore
import transaction, {
  TransactionState
} from 'app/entities/transaction/transaction.reducer';

export interface IRootState {
  readonly authentication: AuthenticationState;
  readonly locale: LocaleState;
  readonly applicationProfile: ApplicationProfileState;
  readonly administration: AdministrationState;
  readonly userManagement: UserManagementState;
  readonly register: RegisterState;
  readonly activate: ActivateState;
  readonly passwordReset: PasswordResetState;
  readonly password: PasswordState;
  readonly settings: SettingsState;
  readonly zone: ZoneState;
  readonly pricing: PricingState;
  readonly session: SessionState;
  readonly event: EventState;
  readonly site: SiteState;
  readonly transaction: TransactionState;
  readonly staticPage: StaticPageState;
  /* jhipster-needle-add-reducer-type - JHipster will add reducer type here */
  readonly order: OrderState;
  readonly payment: PaymentState;
  readonly loadingBar: any;
}

const rootReducer = combineReducers<IRootState>({
  authentication,
  locale,
  applicationProfile,
  administration,
  userManagement,
  register,
  activate,
  passwordReset,
  password,
  settings,
  zone,
  pricing,
  session,
  event,
  site,
  transaction,
  staticPage,
  /* jhipster-needle-add-reducer-combine - JHipster will add reducer here */
  order,
  payment,
  loadingBar
});

export default rootReducer;
